import { I4BButtonColumn } from './i4b-button.column';
import { HeaderType } from '../models';
import { I4bCellConcept } from '../enums';
import { I4BCellType } from '../configurations';

export class I4BSchedulersButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.SCHEDULERS,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          singleActions: [
            {
              order: 10,
              key: 'edit',
              label: 'IOT_DICTIONARY.EDIT',
              enableConditions: [],
              visibleConditions: [[{ key: 'canUpdate', value: true }]]
            },
            {
              order: 20,
              key: 'configure',
              label: 'IOT_DICTIONARY.CONFIGURE',
              enableConditions: [],
              visibleConditions: [[{ key: 'canUpdate', value: true }]]
            },
            {
              order: 30,
              key: 'delete',
              label: 'IOT_DICTIONARY.DELETE',
              enableConditions: [[{ key: 'status', value: 'disabled' }]],
              visibleConditions: [[{ key: 'canDelete', value: true }]]
            },
            {
              order: 25,
              key: 'addDevices',
              label: 'SCHEDULERS.MASTER_VIEW.CTA_LABELS.ADD_DEVICES',
              enableConditions: [],
              visibleConditions: [[{ key: 'canUpdate', value: true }]]
            },
            {
              order: 27,
              key: 'removeDevices',
              label: 'SCHEDULERS.MASTER_VIEW.CTA_LABELS.REMOVE_DEVICES',
              enableConditions: [],
              disableConditions: [[{ key: 'devices.totalCount', value: 0 }]],
              visibleConditions: [[{ key: 'canUpdate', value: true }]]
            },
            {
              order: 5,
              key: 'launchNow',
              label: 'IOT_DICTIONARY.LAUNCH_NOW',
              enableConditions: [],
              visibleConditions: [[{ key: 'canUpdate', value: true }]]
            }
          ],
          bulkActions: [],
          visibleConditions: [
            [
              { key: 'canUpdate', value: true },
              { key: 'canDelete', value: true }
            ]
          ],
          enableConditions: []
        }
      },
      { order: 1000 }
    );
  }
}
